import { networkCommon as listeners, on, off, status } from "../../../web/manager/system/networkCommon";
import isBrowser from "../../../utils/isBrowser";

if (isBrowser && window.addEventListener) {
  window.addEventListener(
    "online",
    function() {
      listeners.networkConnected.forEach(listener => listener());
    },
    false
  );

  window.addEventListener(
    "offline",
    function() {
      listeners.networkDisconnected.forEach(listener => listener());
    },
    false
  );
}

export const network = {
  getStatus() {
    return isBrowser && window.navigator && window.navigator.onLine;
  },
  getIp() {
    return "";
  },
  getConnectionType() {
    return "";
  },
  on,
  off,
  status
};
